export const TaskFeedbacks = {
	['default-unknown-primary']: 'Infelizmente não foi possivel continuar',
	['default-unknown-secondary']: 'Tente novamente mais tarde, já estamos resolvendo.',

	['initialized-sucess-task-primary']: 'A tarefa foi iniciada',
	['initialized-sucess-task-secondary']: 'Agora você já pode editar as informações',

	['not-exist-initialized-task-primary']: 'Essa tarefa já foi concluída ou não existe mais',
	['not-exist-initialized-task-secondary']: 'Você pode buscar uma nova tarefa na caixa de entrada',

	['already-finished-task-primary']: 'Essa tarefa já foi concluída anteriormente',
	['already-finished-task-secondary']:
		'Por favor, volte a caixa de entrada para buscar uma nova tarefa',

	['not-exist-loading-task-secondary']:
		'Parece que essa tarefa já foi concluída ou não existe mais. Por isso não conseguirá carregá-la.',
	['not-exist-abandon-task-secondary']:
		'Parece que essa tarefa já foi concluída ou não existe mais. Por isso não conseguirá abandoná-la.',
	['not-exist-delete-task-secondary']:
		'Parece que essa tarefa já foi concluída, excluída ou não existe mais. Por isso não conseguirá excluí-la.',

	['not-mine-task-primary']: ' já está trabalhando nessa tarefa',
	['not-mine-task-secondary']: 'Por isso não conseguirá iniciá-la',
	['not-mine-task-autosave-secondary']: 'Por isso não conseguirá salvá-la',

	['not-inicialized-task-primary']: ' Opa! essa tarefa não é mais sua!',
	['not-inicialized-task-secondary']: 'Mas se desejar você poderá iniciá-la novamente.',

	['not-inicialized-abandon-primary']: ' Opa! essa tarefa não é mais sua!',
	['not-inicialized-abandon-secondary']:
		'Mas não se preocupe você pode encontrá-la na sua caixa de entrada.',

	['form-submit-invalid-primary']: 'Ainda não é possível concluir esta tarefa!',
	['form-submit-invalid-secondary']: 'Por favor, revise os campos indicados em vermelho.',

	['entity-submit-invalid-primary']: 'Ainda não é possível cadastrar!',
	['entity-submit-invalid-secondary']: 'Por favor, revise os campos indicados em vermelho.',

	['completed-success-primary']: 'A tarefa foi concluída!',
	['completed-success-secondary']: 'Excelente trabalho',

	['abandon-task-sucess-primary']: 'Tarefa abandonada!',
	['abandon-task-sucess-secondary']:
		'A tarefa foi abandonada e esta disponível para outros usuários.',

	['abandon-task-sucess']: 'Tarefa abandonada',

	['delete-task-sucess']: 'Tarefa deletada',

	['delete-pre-register-success']: 'Pré-registro excluído!',

	['date-edit-success']: 'Data prazo da tarefa alterada com sucesso!',
	['date-edit-failed']: 'Não foi possível alterar a data prazo desta tarefa!',

	['date-edit']: 'Alterar data',
	['diligence']: 'Nova diligência',
	['progress']: 'Novo andamento',
	['letter']: 'Novo ofício',
	['finish']: 'Finalizar caso',
	['reopenCase']: 'Reabrir caso',
	['cco']: 'Solicitação',
	['request']: 'Nova solicitação',
	['letter-edit']: 'Edição de solicitação',
	['response']: 'Nova Resposta',
	['cgovInteraction']: 'Novo Complemento',
	['newInteraction']: 'Nova Interação',
	['downloadComplaint']: 'Baixar Reclamação',
	['forensic']: 'Nova Perícia',
};
